/*jslint browser: true, vars: true, nomen: true, indent: 4, maxlen: 200, plusplus: true, sloppy: true, newcap: true, sub: true, regexp: true, continue: true, forin: true*/
/*global mdev: true, console: true, require: true, module: true*/
import api from '../api/user';

export default {
    getInfo: payload => api.getInfo(payload),
    getAuthorDetail: payload => api.getAuthorDetail(payload)

}


// WEBPACK FOOTER //
// ./src/model/service/user.js